import { makeStyles } from '@material-ui/core/styles';

import globalTheme from '../globalTheme';

const useStyles = makeStyles(theme => ({
  searchBarContainer: {
    display: 'flex',
    marginTop: 40,
    marginBottom: 40,
    alignItems: 'center',
    justifyContent: 'space-evenly',
    '& label.Mui-focused': {
      color: 'black'
    },
    '& .MuiInputBase-input': {
      [theme.breakpoints.down('sm')]: {
        width: 161.25
      }
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'grey'
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'grey'
    },
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: globalTheme.palette.primary.main
    },
    '& .MuiPickersDay-daySelected': {
      backgroundColor: globalTheme.palette.primary.main
    },
    '&  .MuiSelect-selectMenu': {
      [theme.breakpoints.down('sm')]: {
        width: 161.25,
        maxWidth: 161.25
      }
    },
    '& .MuiSvgIcon-root': {
      '& .MuiSelect-iconOutlined': {
        [theme.breakpoints.down('md')]: {
          right: -10
        }
      }
    },

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  calendarContainer: {
    width: '100%',
    height: 50,
    display: 'flex',
    justifyContent: 'space-evenly',
    marginBottom: 20
  },
  firstCalendar: {
    [theme.breakpoints.down('md')]: {
      paddingRight: 8
    }
  },
  dateRange: {
    alignSelf: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  formControl: {
    width: 200,
    '&.MuiSelect-outlined': {
      '&.MuiSelect-select': {
        backgroundColor: 'orange'
      }
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'grey'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'grey'
      }
    },
    '&,MuiFormControl-root': {
      [theme.breakpoints.down('md')]: {
        width: 161.25,
        maxWidth: 161.25
      }
    },
    margin: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1)
    }
  }
}));

export default useStyles;
